import type { StateCreator } from 'zustand';
import type { StoreType, SettingsSlice } from '@/types/store';
import { DEFAULT_SETTINGS } from '@/types/persistence';

export const createSettingsSlice: StateCreator<StoreType, [], [], SettingsSlice> = (set, get) => ({
  settings: { ...DEFAULT_SETTINGS },

  setTheme: (theme) => {
    set({ settings: { ...get().settings, theme } });
  },

  updateSettings: (patch) => {
    set({ settings: { ...get().settings, ...patch } });
  },
});
